export default __webpack_public_path__ + "static/media/UN-color.6c6d0ba4.png";